import React, { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import "./Admissions.css";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Link,useNavigate } from "react-router-dom";
function Admissions() {
  const [activeSection, setActiveSection] = useState("");
  const [scrollProgress, setScrollProgress] = useState(0);
  const [admissionsOpen, setAdmissionsOpen] = useState(true);
   const navigate = useNavigate(); 
  useEffect(() => {
    const fetchAdmissionStatus = async () => {
      const settingsRef = doc(db, "settings", "admissions");
      const snap = await getDoc(settingsRef);
      if (snap.exists()) {
        setAdmissionsOpen(snap.data().isOpen);
      }
    };
    fetchAdmissionStatus();
  }, []);
  // Scroll spy + progress
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      let current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 120;
        if (window.scrollY >= sectionTop) current = section.getAttribute("id");
      });
      setActiveSection(current);

      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setScrollProgress((scrollTop / docHeight) * 100);
    };


    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Smooth scroll
  const scrollToSection = (id) => {
    const section = document.querySelector(id);
    if (section) window.scrollTo({ top: section.offsetTop - 100, behavior: "smooth" });
  };

  // Section animation
  useEffect(() => {
    const sections = document.querySelectorAll(".admissions-section");
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("visible");
      }),
      { threshold: 0.2 }
    );
    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    
    <div className="admissions-layout">
    
      <div className="scroll-progress" style={{ width: `${scrollProgress}%` }}></div>

      {/* Sidebar */}
      <aside className="admissions-sidebar">
        <h3>Admissions</h3>
        
        <ul>
          {[
            { id: "#requirements", label: "Admission Requirements" },
            { id: "#tests", label: "Admission Tests" },
            { id: "#criteria", label: "Class Levels & Age Criteria" },
            { id: "#fees", label: "Fee Structure" },
            { id: "#download", label: "Download Form" },
            { id: "#contact", label: "Contact Office" },
            { id: "#faq", label: "FAQs" },
          ].map((item) => (
            <li key={item.id}>
              <a
                href={item.id}
                className={activeSection === item.id.slice(1) ? "active" : ""}
                onClick={(e) => { e.preventDefault(); scrollToSection(item.id); }}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </aside>


      {/* Main Content */}
      
      <div className="admissions-content">
      



        {/* Title */}
        <div className="admissions-title">
          <h1>Admissions</h1>
          <p>Start your journey with us – explore requirements, process, and criteria for joining our school.</p>
        </div>
           {admissionsOpen ? (
            <button className="Apply-btn" onClick={() => navigate("/ApplyForm")}>
              Apply Now
            </button>
          ) : (
            <button className="admission-btn disabled" disabled>
              Admissions Closed
            </button>
          )}

        {/* Admission Requirements Section */}
        <section id="requirements" className="admissions-section card">
          <h2>Admission Requirements</h2>
          <ul className="requirement-list">
            <li><FaCheckCircle className="icon" /> Submit form, pay fee, and receive payment documents.</li>
            <li><FaCheckCircle className="icon" /> Submit 2 photos, Birth Certificate; transfers add last report & character certificates.</li>
            <li><FaCheckCircle className="icon" /> Take the admission test (except Pre-school) and attend parent interview.</li>
            <li><FaCheckCircle className="icon" /> Results are shared within a week.</li>
            <li><FaCheckCircle className="icon" /> Parents receive admission fee challan with payment instructions.</li>
          </ul>
        </section>

        <section id="tests" className="admissions-section card">
          <h2>Admission Tests</h2>
          <p>No written test for Pre-school. For Primary & Secondary, tests are based on the following:</p>
          <div className="test-boxes">
            <div className="test-box red"><p><strong>KG & I</strong></p><p>English, Urdu, Mathematics & General Knowledge (oral)</p></div>
            <div className="test-box blue"><p><strong>Class II – VII</strong></p><p>English, Urdu, Mathematics & Science</p></div>
          </div>
        </section>

        <section id="criteria" className="admissions-section card">
          <h2>Class Levels & Age Criteria</h2>
          <table className="class-table">
            <thead><tr><th>Class Levels</th><th>Age</th></tr></thead>
            <tbody>
              <tr><td>Playgroup</td><td>4+</td></tr>
              <tr><td>Nursery</td><td>5+</td></tr>
              <tr><td>Prep</td><td>6+</td></tr>
              <tr><td>One</td><td>7+</td></tr>
              <tr><td>Two</td><td>8+</td></tr>
            </tbody>
          </table>
        </section>

        <section id="fees" className="admissions-section card">
          <h2>Fee Structure</h2>
          <table className="class-table">
            <thead><tr><th>Classes</th><th>Admission Fee (PKR)</th><th>Monthly Fee (PKR)</th></tr></thead>
            <tbody>
              <tr><td>Playgroup</td><td>5,000</td><td>2,000</td></tr>
              <tr><td>Nursery</td><td>5,000</td><td>2,000</td></tr>
              <tr><td>Prep</td><td>5,000</td><td>2,000</td></tr>
              <tr><td>One</td><td>5,000</td><td>2,500</td></tr>
              <tr><td>Two</td><td>5,000</td><td>2,500</td></tr>
              <tr><td>Three</td><td>5,000</td><td>2,500</td></tr>
              <tr><td>Four</td><td>5,000</td><td>2,500</td></tr>
              <tr><td>Five</td><td>5,000</td><td>2,500</td></tr>
              <tr><td>Six</td><td>5,000</td><td>3,000</td></tr>
              <tr><td>Seven</td><td>5,000</td><td>3,000</td></tr>
              <tr><td>Eight</td><td>5,000</td><td>3,000</td></tr>
              <tr><td>Nine</td><td>5,000</td><td>3,000</td></tr>
              <tr><td>Tenth</td><td>5,000</td><td>3,000</td></tr>
                <tr><td>1st & 2nd Year</td><td>5,000</td><td>5,000</td></tr>
            </tbody>
          </table>
          <p className="note">* Fees may vary by campus. Contact admissions office for updates.</p>
        </section>

        <section id="download" className="admissions-section card center-text">
          <h2>Download Admission Form</h2>
          <p>Please download the admission form and complete it carefully before submission.</p>
          
        <a href="/files/admission-forms.pdf" download className="download-btn">📄 Download Admission Form</a>
        </section>

        <section id="contact" className="admissions-section card">
          <h2>Contact Office</h2>
          <p>Please reach out to our Admissions Office at <strong>+92 304-7630462</strong> or email <strong>academicgroupofschools@gmail.com</strong></p>
        </section>

        <section id="faq" className="admissions-section card">
          <h2>FAQs</h2>
          <ul className="faq-list">
            <li><strong>Q:</strong> What documents are needed for admission?<br /><strong>A:</strong> Birth certificate, photos, last school report.</li>
            <li><strong>Q:</strong> How long does the process take?<br /><strong>A:</strong> Usually 1–2 weeks after the test.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Admissions;
